import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const maxWidthClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  full: 'max-w-full',
} as const

interface PageLayoutProps {
  children: React.ReactNode
  toolbar?: React.ReactNode
  back?: string
  title?: string
  maxWidth?: keyof typeof maxWidthClasses
  fullHeight?: boolean
  className?: string
}

export function PageLayout({
  children,
  toolbar,
  back,
  title,
  maxWidth,
  fullHeight,
  className,
}: PageLayoutProps) {
  if (fullHeight) {
    return (
      <div className={cn('flex flex-col gap-3 lg:h-full', maxWidth && maxWidthClasses[maxWidth], className)}>
        {(back || title) && (
          <div className="flex items-center gap-3 flex-shrink-0">
            {back && (
              <Button variant="ghost" size="icon" asChild>
                <Link to={back}>
                  <ArrowLeft className="h-4 w-4" />
                </Link>
              </Button>
            )}
            {title && <h1 className="text-lg font-semibold">{title}</h1>}
          </div>
        )}
        {toolbar && <div className="flex-shrink-0 space-y-3">{toolbar}</div>}
        <div className="flex-1 min-h-0 min-w-0">{children}</div>
      </div>
    )
  }

  return (
    <div className={cn('lg:h-full lg:overflow-y-auto', maxWidth && maxWidthClasses[maxWidth], className)}>
      {back && (
        <div className="flex items-center gap-3 mb-4">
          <Button variant="ghost" size="icon" asChild>
            <Link to={back}>
              <ArrowLeft className="h-4 w-4" />
            </Link>
          </Button>
          {title && <h1 className="text-lg font-semibold">{title}</h1>}
        </div>
      )}
      {children}
    </div>
  )
}
